/*=========================================================================================
  File Name: moduleUnitsMutations.js
  Description: Units Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  SET_UNITS(state, payload) {
    state.units = payload;
  },
};
